<template>
  <b-modal ref="modal" size="lg" centered :title="$t('WORKINGGROUPFORM')" @close="close()" no-close-on-backdrop no-close-on-esc hide-footer>
      <div class="d-block mt-2">
        <div role="group" class="b-form-group form-group" v-if="formData != null">
          <div class="form-row mb-lg">
            <div class="col-sm-6">
              <b-form-fieldset v-bind:label="$t('NAME')">
                <inputvalidation :formerror="formError" name="name">
                  <b-form-input type="text" v-model="formData.name"></b-form-input>
                </inputvalidation>
              </b-form-fieldset>
            </div>
            <div class="col-sm-6">
              <b-form-fieldset v-bind:label="$t('SURNAME')">
                <inputvalidation :formerror="formError" name="surname">
                  <b-form-input type="text" v-model="formData.surname"></b-form-input>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="form-row mb-lg">
            <div class="col-sm-6">
              <b-form-fieldset v-bind:label="$t('BIRTHDATE')">
                <inputvalidation :formerror="formError" name="birthDate">
                  <lb-vue-datetimepicker type="date" v-model="formData.birthDate" :translate-method="translateDateTimePicker"
                    format="YYYY-MM-DD" display-format="DD.MM.YYYY" :simple="true">
                  </lb-vue-datetimepicker>
                </inputvalidation>
              </b-form-fieldset>
            </div>
            <div class="col-sm-6">
              <b-form-fieldset v-bind:label="$t('PHONENUMBER')">
                <inputvalidation :formerror="formError" name="phoneNumber">
                  <b-form-input type="text" v-model="formData.phoneNumber"></b-form-input>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="form-row mb-lg">
            <div class="col-sm-6">
              <b-form-fieldset v-bind:label="$t('WORKINGGROUPS')">
                <inputvalidation :formerror="formError" name="groupId">
                      <lb-vue-select v-model="formData.groupId"
                              :list="group.root"
                              :totalCount="group.totalCount"
                              :pagination="workingGroupPagination"
                              display-field="name"
                              value-field="workingGroupId"
                              :search-placeholder= "$t('SEARCH')"
                              :items-placeholder= "$t('WORKINGGROUPSEVENT')"
                              v-on:reload="getWorkingGroupData">
                </lb-vue-select>
                </inputvalidation>
              </b-form-fieldset>
            </div>
            <div class="col-sm-6">
              <b-form-fieldset v-bind:label="$t('DATEOFCONTACT')">
                <inputvalidation :formerror="formError" name="dateOfContact">
                  <lb-vue-datetimepicker type="date" v-model="formData.dateOfContact" :translate-method="translateDateTimePicker"
                    format="YYYY-MM-DD" display-format="DD.MM.YYYY" :simple="true">
                  </lb-vue-datetimepicker>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="form-row mb-lg">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('NOTE')">
                <inputvalidation :formerror="formError" name="description">
                  <b-form-textarea type="text" v-model="formData.description" v-bind:placeholder="$t('NOTE')"></b-form-textarea>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
        </div>

        <div class="text-right">
          <b-btn class="mr-2 button-cancel" @click="close()">{{$t('CLOSE')}}</b-btn>
          <b-btn class="button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
      </div>
  </b-modal>
</template>


<script>
import
{
  mapGetters,
}
  from 'vuex';
  import Api from '@/api/group_waiting_list/GroupWaitingList';
import WorkingGroupApi from '@/api/working_group/WorkingGroup';

export default
{
  name: 'GroupWaitingListForm',
  props: ['value'],
  data()
  {
      const me = this;

      return {
          group: {},
          formError: {},
          formData: null,
          workingGroupPagination:
          {
              query: '',
              currentPage: 1,
              limit: 25,
              searchTimeout: false,
          },
      };
  },
  methods:
  {
    translateDateTimePicker(val) {
        const me = this;
        return me.$t(val.toUpperCase());
    },
    async getWorkingGroupData() {
        const me = this;
        try {
          const data = await WorkingGroupApi.selectRow(me.getParamsWorkingGroups);
          if (data.error && data.error === true) {
            me.$notify.notice(data);
            me.loading = false;
            return;
          }

          me.group = data;
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },
      async submitData(item)
      {
          const me = this;
          try
          {                
              if (typeof item.groupWaitingListId !== 'undefined') {
                item.id = item.groupWaitingListId;
                delete (item.groupWaitingListId);
              }

              const data = await Api.submitData(item);
              me.$notify.notice(data);

              if (data.error)
              {
                  me.formError = data;
              }
              else
              {
                  me.close();
              }
          }
          catch (e)
          {
              console.log(e);
              me.$notify.notice(e);
          }
      },
      close()
      {
          const me = this;
          me.formError = {};
          me.formData = null;
          me.$emit('close');
      },
  },
  watch:
  {
      async formData(val)
      {
          const me = this;
          if (val != null)
          {
              await me.getWorkingGroupData();
              me.$refs.modal.show();
          }
          else
          {
              me.$refs.modal.hide();
          }
      },
      value(val)
      {
          const me = this;
          if (val != null)
          {
              me.formData = { ...val };
          }
          else
          {
              me.formData = null;
          }
      },
  },
  computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParamsWorkingGroups()
      {
          const me = this;
          const data = {
              ...me.workingGroupPagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
